import { render } from "./imgAppVpass.vue?vue&type=template&id=f85480d6&scoped=true"
import script from "./imgAppVpass.vue?vue&type=script&lang=js"
export * from "./imgAppVpass.vue?vue&type=script&lang=js"

import "./imgAppVpass.vue?vue&type=style&index=0&id=f85480d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85480d6"]])

export default __exports__